import { Controller } from 'stimulus'

export default class extends Controller {
    initialize() {
        this.startTime = new Date()
    }
    
    connect() {
        this.tick = setInterval(() => {
            // I guess this could be slippery
            let fixedTimeRemaining = this.timeRemaining

            if (fixedTimeRemaining === 0) {
                // make sure the message is hidden and the button enabled
                this.messageBox.setAttribute('hidden', true)
                this.button.classList.remove('disabled')
            } else {
                // update message
                if (fixedTimeRemaining < 60000) {
                    this.message.textContent = 'You have less then a minute of study time remaining.'
                } else {
                    let minutesRemaining = Math.round(fixedTimeRemaining / 60000)
                    this.message.textContent = `You have ${minutesRemaining} minute(s) of study time remaining.`
                }
            }
        }, 1000)
    }

    advance(e) {
        if (this.timeRemaining !== 0) {
            e.preventDefault()
        }
    }

    get minTime() {
        if (this.data.has('min-time')) {
            // Assume it's in minutes so do the conversion here
            return this.data.get('min-time') * 60000
        } else {
            return 1000;
        }
    }

    get timeRemaining() {
        let timeElapsed = new Date() - this.startTime
        return Math.max(this.minTime - timeElapsed, 0)
    }

    get message() {
        return this.targets.find('message')
    }

    get messageBox() {
        return this.targets.find('message-box')
    }
    
    get button() {
        return this.targets.find('button')
    }
}
